import { faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Fab, Modal } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
const FinalGradeDetail = ({currentFinalGrade, showModal, setShowModal}) => {
    const navigate = useNavigate()
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color:'black',
        transform: 'translate(-50%, -50%)',
        minWidth: '80%',
        minHeight: '85%',
        maxHeight: '85%',
        overflowY:'auto',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
      };
    const handleClose = () => {
        setShowModal(false)
      };
      if(!currentFinalGrade) return <></>
  return (
    <Modal
  open={showModal}
  onClose={handleClose}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
  disableScrollLock={true}
>
    
  <Box id="modal-grades" sx={{ ...style }}>
    <div className='modal-header'>
     <div className='modal-header-text'>
     <h2 >{currentFinalGrade.username}  {currentFinalGrade.fullname} </h2>
    <h3>{currentFinalGrade.finalGradeBase?.courseName} ( {currentFinalGrade.finalGradeBase?.year} {currentFinalGrade.finalGradeBase?.semester})</h3>
    <span className='small-text'>{currentFinalGrade.finalGradeBase?.groupName}</span>
    <h3 > ציון משוקלל : {currentFinalGrade.total?.toFixed(2)}</h3>
     </div>
     <div className='modal-header-actions'>
    
     <Fab  onClick={() => window.print()} variant="extended">
     <FontAwesomeIcon   icon={faPrint} /> 
</Fab>
 <Fab onClick={handleClose} variant="extended">
            <FontAwesomeIcon icon={faTimes} />
</Fab>
     </div>
    </div>
   
    <p id="parent-modal-description"></p>
    <table className={`table table--finalGradesDetails  `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th finalGrade__body">סוג</th>
                        <th scope="col" className="table__th finalGrade__title">משימה </th>
                        <th scope="col" className="table__th finalGrade__title">תאריך </th>
                        <th scope="col" className="table__th finalGrade__dates"> משקל </th>
                        <th scope="col" className="table__th finalGrade_student "> ציון </th>
                        <th scope="col" className="table__th finalGrade_student "> ציון משוקלל </th>
                    </tr>
                </thead>
                <tbody>
                   {currentFinalGrade.grades.map(grade=>{
                     return (
                        <tr key={grade.oId} className="table__row">
                            <td className={`table__cell finalGrade__dates `} >{grade.from==="Tasks"? "משימה": grade.from==="Questions"? "שאלון": grade.from}  </td>
                            <td className={`table__cell finalGrade__title `}>{grade.name}</td>
                            <td className={`table__cell finalGrade__dates `} >{grade.dt?.toString().slice(0,10)}  </td>
                            <td className={`table__cell finalGrade_student `} > {grade.ratio?.toFixed(2)}%</td>
                            <td className={`table__cell finalGrade_student`} >{grade.grade?.toFixed(2)}</td>
                            <td className={`table__cell finalGrade_student`} >{grade.calculateGrade?.toFixed(2)}</td>

                        </tr>
                    )
                   })}
                </tbody>
            </table>
    
           
  </Box>
</Modal>
  )
}

export default FinalGradeDetail